module.exports = __webpack_public_path__ + "img/ok-newbie.471383ef.png";